import Index from './index.vue'
import List from './components/List.vue'

export default [
  {
    path: '/commit',
    name: 'commit',
    component: Index,
    title: 'Commit',
    redirect: { name: 'commit-list' },
    children: [
      {
        path: 'dashboard',
        name: 'commit-list',
        component: List,
      },
    ],
  },
]
